
/**
 * This is used for integration with Hilton's Fusion application
 * For testing, navigate to: /#/internal/connector
 * See also: MessagingModule, ConnectorModule
 */

/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Injectable } from '@angular/core';
import { WindowMessageService, WindowMessage } from './window-message.service';

@Injectable()
export class PostMessageService {

  private isInitialized: boolean = false;

  constructor(private messageService: WindowMessageService) { }

  initialize() {
    if (!this.isInitialized) {
      this.isInitialized = true;

      const opener = (!window.opener?.closed) ? window.opener : undefined;

      // Listen for external messages (can't be an actual method, since something in the call mucks up the "this")
      const receiveMessage = (e: MessageEvent) => {
        const messageType = e?.data?.type;
        if (typeof messageType !== 'string') return;
        const message: WindowMessage = messageType?.includes('konexus') ? e.data : undefined;
        if (!message) return;
        try {
          // Always echo back acknowledgment (even if we encounter errors processing)
          opener?.postMessage({
            type: 'konexus.ack',
            message: 'received',
            data: e.data
          }, '*');

          this.messageService.processMessage(message);

        } catch (err) {
          this.callbackError(err.message, message);
        }
      }

      window.addEventListener('message', receiveMessage, false);

      // Inform that we loaded and are listening to postMessage
      opener?.postMessage({
        type: 'konexus.ack',
        message: 'loaded'
      }, '*');
    }
  }

  private callbackError(errorMessage: string, message?: WindowMessage) {
    opener?.postMessage({
      type: 'konexus.error',
      message: errorMessage,
      data: message
    }, '*');
  }
}
